export default "__VITE_ASSET__D6ppRI8q__"